import LegalDocumentPage from "../../utils/LegalDocumentPage";
import termsAndConditionsContent from "../../content/termsAndConditionsContent.json";

const TermsAndConditions = () => <LegalDocumentPage content={termsAndConditionsContent} />;

export default TermsAndConditions;
